import { RadioProps } from "@bluframe/blublocks"
import {
  NewsServiceName,
  NewsSource,
  Review,
  ReviewsServiceName
} from "@bluframe/mightychroma-mightytool-frontend-types"

import Card from "./Card"

export interface Props {
  actions: React.ReactNode
  avatar: string
  display: NewsSource[] | Review[]
  flagLoading: boolean
  isShowFlagButton: boolean
  label: string
  name: string
  onSelect: RadioProps["onChange"]
  onToggleFlagged: (id: string, isFlagged: boolean) => () => void
  selected: string
  serviceName: NewsServiceName | ReviewsServiceName
  subheader: string
  title: string
}

export interface ComponentProps extends Props {}

export default Card
